import getNewState from "../../utils/stateModifier";
import { onStart, onError, onFinish } from "../../httpService";
import {
  MFA_VERIFY_FACTOR,
  MFA_RESEND_CODE,
  UPDATE_RESEND_CODE_TIMER,
  RESET_SUCCESS_STATE,
  SUCCESS_MESSAGE,
} from "./constants";
import { oktaErrorMessage } from "../../utils/messageExtractor";
import { PASSCODE_SUBMIT } from "../VerifyPasscode/constants";

export const initialState = {
  isLoading: false,
  isError: false,
  errorMessage: "",
  isSuccess: false,
  successMessage: "",
  isResendCodeLoading: false,
  addedMfaFactor: {},
  mfaSuccessMessage: "",
};

const actionMap = new Map();
actionMap.set(UPDATE_RESEND_CODE_TIMER, (state, action) => ({
  ...state,
  intervalToResendCode: action.data,
}));
actionMap.set(RESET_SUCCESS_STATE, (state, action) => ({
  ...state,
  isSuccess: false,
  successMessage: "",
}));

actionMap.set(onStart(MFA_VERIFY_FACTOR), (state, action) => ({
  ...state,
  isLoading: true,
  isError: false,
  isSuccess: false,
  errorMessage: "",
  successMessage: "",
}));
actionMap.set(onFinish(MFA_VERIFY_FACTOR), (state, action) => ({
  // moved to login reducer
  ...state,
  isLoading: false,
  isError: false,
  isSuccess: false,
  errorMessage: "",
}));
actionMap.set(onError(MFA_VERIFY_FACTOR), (state, action) => ({
  ...state,
  isLoading: false,
  isError: true,
  isSuccess: false,
  errorMessage: oktaErrorMessage(action, "Session expired"),
}));

actionMap.set(onStart(MFA_RESEND_CODE), (state, action) => ({
  ...state,
  isResendCodeLoading: true,
  isError: false,
  isSuccess: false,
  errorMessage: "",
  successMessage: "",
}));
actionMap.set(onFinish(MFA_RESEND_CODE), (state, action) => ({
  ...state,
  isResendCodeLoading: false,
  isError: false,
  isSuccess: true,
  successMessage: "New code send successfully",
  errorMessage: "",
}));
actionMap.set(onError(MFA_RESEND_CODE), (state, action) => ({
  ...state,
  isResendCodeLoading: false,
  isError: true,
  isSuccess: false,
  successMessage: "",
  errorMessage: oktaErrorMessage(action, "Session expired"),
}));
actionMap.set(onError(PASSCODE_SUBMIT), (state, action) => ({
  ...state,
  isResendCodeLoading: false,
  isError: true,
  isSuccess: false,
  successMessage: "",
  errorMessage: action.data.errorSummary,
}));
actionMap.set(onFinish(PASSCODE_SUBMIT), (state, action) => ({
  ...state,
  addedMfaFactor: {},
}));
actionMap.set(SUCCESS_MESSAGE, (state, action) => ({
  ...state,
  mfaSuccessMessage: action.data,
}));

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action) => {
  return getNewState(state, action, actionMap);
};
